export const getSortKeysSchema = (schema) => {
    return (Object.keys(schema).sort((a, b) => a - b))
};